// JavaScript source code
import React from "react";
import Nav from "../components/Nav";
import Contacts from "../components/Contact";



function Contact() {
    return (
        <div>
            <Nav />
            <p>Contact me</p>
            <Contacts />
        </div>
    );
}

export default Contact;
